import { CurrencyConverter } from 'gunsi-auth'
import { useEven } from '../hooks/useEven.jsx'
import { useEvenI18n } from '../i18n/even.js'

// Wrapper sottile: il convertitore vero è il componente CONDIVISO in
// gunsi-auth (una modifica lì arriva a tutte le app al build successivo).
export function Converter() {
  const t = useEvenI18n()
  const { currency } = useEven()

  return (
    <main className="page page-converter">
      <header className="page-head">
        <h1>{t.converter.title}</h1>
      </header>
      <CurrencyConverter defaultFrom={currency || 'EUR'} />
    </main>
  )
}
